import { AlertsComponent, AlertsService } from '@web/shared/ui';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';

import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';
import { once } from '@web/utils';
import { AdminBannerDetailsFormComponent } from '../admin-banner-details-form/admin-banner-details-form.component';
import { AdminBannerDataSourceService } from '../../services/admin-banner-data-source.service';
import { AdminBannerDetailsForm } from '../../models/admin-banner-details-form';
import { BannerLocationType } from '../../../shared/enums/banner-location-type';

@Component({
  selector: 'app-admin-banner-create',
  imports: [AlertsComponent, AdminBannerDetailsFormComponent],
  templateUrl: './admin-banner-create.component.html',
  styleUrl: './admin-banner-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminBannerCreateComponent {
  private readonly bannerDataSource = inject(AdminBannerDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly location = input<BannerLocationType | null>(null);
  public readonly allowedLocations = input<BannerLocationType[]>([
    BannerLocationType.HomePageHeader,
    BannerLocationType.SubscribePageHeader,
  ]);
  public readonly submitSuccessEvent = output<void>();

  public handleSubmitClickEvent(data: AdminBannerDetailsForm): void {
    const location = this.location();
    const request$ = location
      ? this.bannerDataSource.createByFormDataAndLocation({ data, location })
      : this.bannerDataSource.createHeaderByFormData({ data });

    request$.pipe(once()).subscribe({
      next: () => this.notifySubmitSuccessEvent(),
      error: (response) => this.showFailureAlertByResponse(response),
    });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
